import React from 'react'

const NoResultFound = ({fromError, fromSearch, fromFilters, language}) => {
  const {noResultFound,noResultFoundSubText,emptyListLabel,filterNoBookSubText, errorLabel, errorSubText} = language;
  return (
    <div className="no-result-container">
      <div className={fromError ? "error-icon":fromSearch || fromFilters? "no-result-found-icon" : "empty-list-icon"}></div>
      <div className="results-label">{fromError? errorLabel:fromSearch || fromFilters?noResultFound:emptyListLabel}</div>
      <div className="results-sub-text">{fromError? errorSubText:fromSearch? noResultFoundSubText: fromFilters?filterNoBookSubText:""}</div>
    </div>
  )
}

export default NoResultFound
